<script>
export default {
  name: "DidoApidocDataOrganization",
};
</script>

<script setup>
import { ref, computed, inject } from "vue";
import api from "../../api";
import datasStructureSvg from "../../assets/data-structure.svg";

const apiUrl = inject("apiUrl");

const parquetEnabled = ref(false);
api.withParquet(apiUrl).then((result) => (parquetEnabled.value = result));

const outputFormats = computed(() =>
  parquetEnabled.value
    ? "csv, xlsx, json, parquet ou geojson"
    : "csv, xlsx, json ou geojson",
);
</script>

<template>
  <div class="q-mt-md line-height-15">
    <QImg
      :src="datasStructureSvg"
      alt="Schéma de la structure des données de DiDO"
      height="auto"
      width="100%"
    />
    <br />
    <br />
    Les données diffusées par DiDo sont organisées ainsi :
    <ul class="data-structure-list">
      <li>
        Les données relatives à un même sujet sont regroupées dans des
        <span class="text-bold">jeux de données</span> (Datasets) auxquels sont
        associés des métadonnées (thème, mots-clés, couverture géographique et
        temporelle, fréquence d'actualisation, etc...) afin de pouvoir les
        rechercher ou retrouver facilement.
      </li>
      <li>
        Chaque <span class="text-bold">jeu de données</span> contient des
        <span class="text-bold">fichiers de données</span> (Datafiles) et peut
        également contenir des
        <span class="text-bold">fichiers annexes</span> (Attachments).
      </li>
      <li>
        Un <span class="text-bold">fichier annexe</span> est un fichier statique
        (pdf, image, etc...) qui permet d'apporter des informations
        supplémentaires concernant un
        <span class="text-bold">jeu de données</span>. Il peut être de type :
        <ul>
          <li>
            <span class="underline-dotted">documentation</span> (exemple : un
            dictionnaire de variables, une note méthodologique),
          </li>
          <li>
            <span class="underline-dotted">données historiques</span>
            (exemple : données archivées).
          </li>
        </ul>
      </li>
      <li>
        Un <span class="text-bold">fichier de données</span> contient des
        données qui peuvent exister dans différentes versions ou
        <span class="text-bold">millésimes</span>.
      </li>
      <li>
        Un <span class="text-bold">millésime</span> contient les données qui
        peuvent être récupérées dans divers formats ({{ outputFormats }}).
      </li>
      <li>
        Les donnés diffusées peuvent être liées à :
        <ul>
          <li>
            des référentiels externes : par exemple le COG (Code Officiel
            Géographique) ou la NAF (Nomenclature des Activités Françaises),
          </li>
          <li>
            des reférentiels internes au SDES (appelés nomenclatures) : par
            exemple la nomenclature du bilan de l'énergie et bien d'autres.
          </li>
        </ul>
      </li>
    </ul>
  </div>
</template>
